import { render, staticRenderFns } from "./WeeksAddUpdate.vue?vue&type=template&id=3308f46f&"
import script from "./WeeksAddUpdate.vue?vue&type=script&lang=js&"
export * from "./WeeksAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./WeeksAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports